export default __webpack_public_path__ + "static/media/941.1b77e38b.gif";